import React from "react";
import { useAuth } from "../helpers/useAuth";
import { DashboardLayout } from "./DashboardLayout";
import { TenantPortalLayout } from "./TenantPortalLayout";

interface AdaptiveLayoutProps {
  children: React.ReactNode;
}

export const AdaptiveLayout: React.FC<AdaptiveLayoutProps> = ({ children }) => {
  const { authState } = useAuth();

  // If we are not authenticated yet or in a loading state, 
  // we just render children (typically ProtectedRoute will catch this anyway)
  if (authState.type !== "authenticated") {
    return <>{children}</>;
  }

  // Render the appropriate layout based on the user's role
  if (authState.user.role === "tenant") {
    return <TenantPortalLayout>{children}</TenantPortalLayout>;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
};

export default AdaptiveLayout;